export default "/_next/static/fonts/5c4610fc0fecb1ce68959c5e6aa522c5.ttf";